import gql from 'graphql-tag';

export default gql`
  mutation uploadFileToPrint($input: UploadFileToPrintInput!) {
    uploadFileToPrint(input: $input) {
      url
      key
      path
      name
      type
      size
    }
  }
`;
